import gql from 'graphql-tag';

const query = gql`
    mutation subscribe($input: SubscribeInput!){
        subscribe(input: $input)
    }
`;

export default query;
